




























import Vue from 'vue'
import Autocomplete from '@/components/Autocomplete.vue'
import { getAgencies } from '@/api/Agency/agency.api'
import { getAgencyPrices } from '@/api/Topup/topup.api'
import { required } from '@/utils/validators'
import PieChart from '../../Statistics/PieChart.vue'
import TitleButton from '@/components/TitleButton.vue'

export default Vue.extend({
  components: {
    appAutocomplete: Autocomplete,
    appPieChart: PieChart,
    appTitleButton: TitleButton,
  },
  props: {
    product: String,
  },
  data() {
    return {
      rules: {
        required: (v: string) => required(v) || this.$t('field-required'),
      },
      form: false,
      crud: {
        agency__uuid: this.$store.getters.profile.agency,
        product__amount: this.product,
      },
      getAgencies: getAgencies,
      data: [] as number[],
      labels: [] as string[],
      loading: false,
    }
  },
  methods: {
    refresh() {
      this.getData()
    },
    async getData() {
      try {
        this.loading = true
        const response = await getAgencyPrices({ ...this.crud })
        this.data = []
        this.labels = []
        response.data.results.forEach(price => {
          if (price.is_active) {
            this.labels.push(price.provider_name)
            this.data.push(price.rate)
          }
        })
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    'crud.agency__uuid'(value: boolean) {
      if (value) {
        this.getData()
      }
    },
  },
  mounted() {
    this.getData()
  },
})
